export interface Unit {
  unitId: string;
  name: string;
  address: string;
  phone?: string;
  imageUrl?: string;
  deleted?: boolean;
  daysWithRushHoursList: { [day: string]: IRushHour[] };
}

export interface IRushHour {
  startDate: Date;
  endDate: Date;
  startHour: string;
  endHour: string;
  rushLevel: 0 | 50 | 100;
}

export const RUSH_LEVELS = {
  0: {
    value: 0,
    label: "Pouco movimento",
    color: "#025F00",
    contrastColor: "#fff",
  },
  50: {
    value: 50,
    label: "Movimento médio",
    color: "#FBFF3D",
    contrastColor: "#000000",
  },
  100: {
    value: 100,
    label: "Muito movimento",
    color: "#FF0000",
    contrastColor: "#fff",
  },
};
